
import { SiFirebase,SiFlutter,SiSqlite,SiGooglemaps,SiStripe ,SiPaypal,SiApple,SiGoogle,SiGooglecolab} from "react-icons/si";
import { SiReact,SiDart,SiFastapi,SiRazorpay,SiFing,SiAmazonaws,SiFacebook,SiLinkedin} from "react-icons/si";

// Features Data
export const featuresData = [
  {
    id: 1,
    icon: <SiFlutter />,
    title: "Flutter App Development",
    des: "A google's cross-platform UI toolkit for mobile, web, and desktop applications of flutter app is fast Development,Expensive and Flexible UI & Native Performance.",
  },
  {
    id: 2,
    icon: <SiFirebase />,
    title: "Firebase",
    des: "Firebase is an app development platform that helps you buid and grow apps and games users love."+
    "Backed by Google and trusted by milons of businesses around the world.",
  },
  {
    id: 3,
    icon: <SiDart />,
    title: "Dart",
    des: "Dart is an open source general purpose programming language,"+
    "it is originaly developed by Googla Dart is an object-criented language with cstyle syntax.",
  },
  {
    id: 4,
    icon: <SiReact/>,
    title: "React",
    des: "React is a JavaScript-based UI development library. Facebook and an open-source developer community run it. Although React is a library rather than a language, it is widely used in web development. ",
  },
  {
    id: 5,
    icon: <SiFastapi />,
    title: "API Integration",
    des: "API is the acronym for Appication Programming Interface, which is a software intermediary that allows two applications to talk to each other.",
  },
  {
    id: 6,
    icon: <SiSqlite />,
    title: "SQLite",
    des: "SQLite is a database engine written in the C programming language. It is not a standcione app; rather,"+
    "it is a ibrary that software developers embed in their apps.",
  },
  {
    id: 7,
    icon: <SiGooglemaps />,
    title: "Google Map",
    des: "Google Maps is a web mapping platform and consumer application offered by Googla it offers sotalite"+
    "imogery, carial photography,"+
    "street maps, 360° interactive panoramic views of streets.",
  },
  {
    id: 8,
    icon: <SiStripe />,
    title: "Stripe",
    des: "The Stripe Flutter SDK allows you to buid delightful payment experiences in your native Android and los"+
    "apps using Flutter."+
    "we provida powerful and customizable UI screens and elements that can ba used o..",
  },
  {
    id: 9,
    icon: <SiRazorpay />,
    title: "Razorpay",
    des: "The One Stop For Payment Pages, Links, Involces, subscription, Payouts, Reminders And More. Fostest"+
    "chackout experience with 100+ paymode modes all cards, UPI,"+
    "EMl wolats and mora.",
  },
  {
    id: 10,
    icon: <SiFing />,
    title: "Fingerprint",
    des: "A fingerprint is an impression left by the friction ridges of a humon finger. The recovery of portial"+
    "fingerprints from a crime scene is an important mathod of"+
    "forensic scienca.",
  },
  {
    id: 11,
    icon: <SiAmazonaws />,
    title: "AWS",
    des: "Amazon Web Saricas Inc. (Aws) is a subsidiary of Amazon that provides on-demand doud computing platforms and"+
    "Aris to individuals companies and govemments on a metered pay-as-you-..",
  },
  {
    id: 12,
    icon: <SiPaypal />,
    title: "PayPal",
    des: "Paypal is the faster, safer wory to send and receive money or make on online payment."+
    "Get storted or create a merchant account to accept payments.",
  },
  {
    id: 13,
    icon: <SiFacebook />,
    title: "Facebook",
    des: "Facebook is an online social media and social networking service owned by"+
    "American company Meta Platforms.",
  },
  {
    id: 14,
    icon: <SiLinkedin />,
    title: "Linkedin",
    des: "Linkedin is an American business and employment-oriented"+
    "online service that operates via websites and mobile apps.",
  },
  {
    id: 15,
    icon: <SiApple />,
    title: "Apple",
    des: "Apple Inc. is an American mutinational technology company headquartered in"+
    "Cupertino, Califomio, United States.",
  },
  {
    id: 16,
    icon: <SiGoogle />,
    title: "Google",
    des: "Google LIC is on American mutinational technology company focusing on search engine technology,"+
    "onine advertising. cloud computing computer softwore, quantum computing, e-commerce, artifici...",
  },
  {
    id: 17,
    icon: <SiGooglecolab />,
    title: "Google Console",
    des: "Google Search Console tools and reports help you measure your ste's search traffic and pertormonce,"+
    "fix issues, and make your site shine in Google Search results.",
  },
];
